// Generic-pair props for the flat all-orgs picker (superadmin surfaces) —
// flat rows (`should_serialize=false` → no JSON:API envelope, hence explicit
// accessors). Spread into APMultiSelect / APFormCombobox:
//   <APMultiSelect {...useOrgsSelect()} value={…} onChange={…} />
// Extract-on-second-consumer: groups filters + users filters.
import type { CrudFilter } from '@refinedev/core';

export interface OrgsSelectProps {
  resource: 'orgs';
  optionLabel: string;
  optionValue: string;
  filters: CrudFilter[];
}

const ORGS_SELECT_PROPS: OrgsSelectProps = {
  resource: 'orgs',
  optionLabel: 'name',
  optionValue: 'id',
  filters: [{ field: 'should_serialize', operator: 'eq', value: false }],
};

export const useOrgsSelect = (): OrgsSelectProps => ORGS_SELECT_PROPS;
